// 지문 내용 작성 글자수 제한
export const MAX_PASSAGE_LENGTH = 2500